import {
  FormPanel,
  FormTextField,
  FormAutocomplete,
  FormCheckbox,
  Params,
  ApiFilterOperation,
  FormContext,
} from '@eas/common-web';
import React, { useEffect, useContext } from 'react';

import {
  useMinimalDistancesCategoryAutocomplete,
  useMinimalDistancesDeterminationMethodAutocomplete,
  useOVZFacilityDetail,
} from '../../minimal-distances/minimal-distances-api';
import { HelpLabel } from '../../../components/help/help-label';

import { ProcessForm } from '../minimal-distances-new-types';
import { OvzFacility } from '../../../models';
import { dictionaryLabelMapper } from '../../../components/form/mappers/label-mappers';
import _ from 'lodash';

const getLivestockFilter = (ovzFacility?: OvzFacility): Params | undefined => {
  if (!ovzFacility || !ovzFacility?.withOnlyLivestockSource) {
    return undefined;
  }
  return {
    filters: [
      {
        field: 'code',
        operation: ApiFilterOperation.START_WITH,
        value: '8.',
      },
    ],
  };
};

export function StepSourceSpecificationContent({
  allValues,
}: {
  allValues?: ProcessForm;
}) {
  const { result: ovzFacilityDetail, loading } = useOVZFacilityDetail(
    allValues?.ovzFacility?.id
  );
  const { setFieldValue } = useContext(FormContext);

  useEffect(() => {
    setFieldValue('ovzFacility', ovzFacilityDetail);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allValues?.ovzFacility?.id, ovzFacilityDetail?.id]);

  const categoryAutocomplete = useMinimalDistancesCategoryAutocomplete(
    getLivestockFilter(ovzFacilityDetail)
  );
  const determinationAutocomplete = useMinimalDistancesDeterminationMethodAutocomplete();

  if (loading) {
    return <>Loading ... </>;
  }

  return (
    <FormPanel label="Vyplňte">
      <FormTextField
        name="sourceId"
        label={
          <HelpLabel
            label="Číslo zdroje"
            code="MINIMAL_DISTANCES_NEW_SOURCE_ID"
            required
          />
        }
      />
      <FormTextField
        name="name"
        label={
          <HelpLabel
            label="Název zdroje"
            code="MINIMAL_DISTANCES_NEW_SOURCE_NAME"
            required
          />
        }
      />

      <FormAutocomplete
        name="sourceCategory"
        source={categoryAutocomplete}
        labelMapper={dictionaryLabelMapper}
        notifyChange={async (value) => {
          // dont mind if item is undefined, clearing the field is what we want in that case
          setFieldValue(
            'determinationMethod',
            _.get(value, 'determinationMethod')
          );
        }}
        label={
          <HelpLabel
            label="Zařazení zdroje podle přílohy č. 2a zákona"
            code="MINIMAL_DISTANCES_NEW_SOURCE_CATEGORY"
            required
          />
        }
      />
      <FormAutocomplete
        name="determinationMethod"
        source={determinationAutocomplete}
        disabled
        labelMapper={dictionaryLabelMapper}
        label={
          <HelpLabel
            label="Způsob určení minimální vzdálenosti podle § 27d"
            code="MINIMAL_DISTANCES_NEW_DETERMINATION_METHOD"
            required
          />
        }
      />
      <FormCheckbox
        name="exemptFromMinDistances"
        label={
          <HelpLabel
            label="Výjimka z MV"
            code="MINIMAL_DISTANCES_NEW_EXEMPT_FROM_MIN_DISTANCES"
          />
        }
      />
    </FormPanel>
  );
}
